__turbopack_context__.v({
  "closed": "Contact-module__hcVmEa__closed",
  "form": "Contact-module__hcVmEa__form",
  "formCard": "Contact-module__hcVmEa__formCard",
  "formHeader": "Contact-module__hcVmEa__formHeader",
  "formRow": "Contact-module__hcVmEa__formRow",
  "formSubtitle": "Contact-module__hcVmEa__formSubtitle",
  "formTitle": "Contact-module__hcVmEa__formTitle",
  "hiddenText": "Contact-module__hcVmEa__hiddenText",
  "hoursGrid": "Contact-module__hcVmEa__hoursGrid",
  "hoursRow": "Contact-module__hcVmEa__hoursRow",
  "hoursSection": "Contact-module__hcVmEa__hoursSection",
  "infoCard": "Contact-module__hcVmEa__infoCard",
  "infoDivider": "Contact-module__hcVmEa__infoDivider",
  "infoIcon": "Contact-module__hcVmEa__infoIcon",
  "infoItem": "Contact-module__hcVmEa__infoItem",
  "infoLabel": "Contact-module__hcVmEa__infoLabel",
  "infoLink": "Contact-module__hcVmEa__infoLink",
  "infoList": "Contact-module__hcVmEa__infoList",
  "infoPanel": "Contact-module__hcVmEa__infoPanel",
  "infoSubtitle": "Contact-module__hcVmEa__infoSubtitle",
  "infoTitle": "Contact-module__hcVmEa__infoTitle",
  "infoValue": "Contact-module__hcVmEa__infoValue",
  "input": "Contact-module__hcVmEa__input",
  "inputGroup": "Contact-module__hcVmEa__inputGroup",
  "label": "Contact-module__hcVmEa__label",
  "layout": "Contact-module__hcVmEa__layout",
  "liveDot": "Contact-module__hcVmEa__liveDot",
  "livePulse": "Contact-module__hcVmEa__livePulse",
  "mainSection": "Contact-module__hcVmEa__mainSection",
  "mapIframe": "Contact-module__hcVmEa__mapIframe",
  "officeAddress": "Contact-module__hcVmEa__officeAddress",
  "officeBadge": "Contact-module__hcVmEa__officeBadge",
  "officeCard": "Contact-module__hcVmEa__officeCard",
  "officeCity": "Contact-module__hcVmEa__officeCity",
  "officeGrid": "Contact-module__hcVmEa__officeGrid",
  "officeInfo": "Contact-module__hcVmEa__officeInfo",
  "officeMapWrap": "Contact-module__hcVmEa__officeMapWrap",
  "quickCard": "Contact-module__hcVmEa__quickCard",
  "quickGrid": "Contact-module__hcVmEa__quickGrid",
  "quickIcon": "Contact-module__hcVmEa__quickIcon",
  "quickLabel": "Contact-module__hcVmEa__quickLabel",
  "quickStrip": "Contact-module__hcVmEa__quickStrip",
  "quickText": "Contact-module__hcVmEa__quickText",
  "quickValue": "Contact-module__hcVmEa__quickValue",
  "spin": "Contact-module__hcVmEa__spin",
  "spinner": "Contact-module__hcVmEa__spinner",
  "submitBtn": "Contact-module__hcVmEa__submitBtn",
  "textarea": "Contact-module__hcVmEa__textarea",
});
